// just for test mocking
export const getHostname = () => window.location.hostname;